// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"p2-z"};